export default __webpack_public_path__ + "static/article-travelling-around-australia-on-a-budget-27e24cd14b4ae43cc7faa24134a2511f.jpg";